var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropAHint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.769592,
    width: 17,
    height: 11.4615,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25684 4.28119C9.99016 3.54819 11.1789 3.54799 11.9121 4.28119C12.6449 5.01442 12.645 6.20327 11.9121 6.93646L11.6562 7.19232L11.666 7.20209L9.00977 9.85736L9 9.8476L8.99121 9.85736L6.33496 7.20209L6.34473 7.19232L6.08887 6.93646C5.35588 6.2032 5.35583 5.01442 6.08887 4.28119C6.82218 3.54807 8.01188 3.54795 8.74512 4.28119L9 4.53607L9.25684 4.28119ZM11.2051 4.98822C10.8625 4.64562 10.3067 4.64567 9.96387 4.98822L9.96094 4.99115L9.7041 5.24603L8.99707 5.9472L8.03809 4.98822C7.7168 4.66693 7.20713 4.64666 6.8623 4.92767L6.7959 4.98822C6.45343 5.33087 6.45338 5.88664 6.7959 6.22943L7.75879 7.19232L7.74902 7.20111L8.95215 8.40521L8.96191 8.39545L9.00977 8.4433L10.251 7.20111L10.2422 7.19232L11.2051 6.22943C11.526 5.90823 11.5464 5.39931 11.2656 5.05463L11.2051 4.98822Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.346191 0.615967L6.23081 4.85289M17.6539 0.615967L11.7693 4.85289",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropAHint);
export default __webpack_public_path__ + "static/media/drop-a-hint.2b77b061f78bbb6061091fc1939c24e7.svg";
export { ForwardRef as ReactComponent };